import { Liquid } from "liquidjs";
import czech from './czech.1029.json';
import english from './english.1033.json';

export const DEFAULT_LANGUAGE = 1029;
export const FALLBACK_LANGUAGE = 1033;
export const SUPPORTED_LCIDS = [1029, 1033] as const;

type SupportedLCIDs = typeof SUPPORTED_LCIDS[number];

export class Localization {
    private _liquid: Liquid = new Liquid();
    private _localizationLCID = this._getLocalizationLCID();
    private _translations = this._loadTranslations();
    //needs to be singleton, if static class, the code for fetching the localization LCID would run immediately
    //when client libraries loads => this can result in calling window.Xrm methods that have not yet been created
    private static _instance: Localization;

    private constructor() {

    }

    public static GetString(key: string, variables?: object) {
        if (!this._instance) {
            this._instance = new Localization();
        }
        return this._instance.getString(key, variables);
    }

    public getString(key: string, variables?: object) {
        const translation = this._translations[this._localizationLCID][key];
        if (!translation) {
            return key;
        }
        return this._liquid.parseAndRenderSync(translation, variables);
    }

    private _getLocalizationLCID(): SupportedLCIDs {
        const userLCID = window.Xrm.Utility.getGlobalContext().userSettings.languageId;
        const supportedLCID = SUPPORTED_LCIDS.find(lcid => lcid === userLCID);
        if (!supportedLCID) {
            console.warn(`Translations not available for LCID ${userLCID}, falling back to ${DEFAULT_LANGUAGE}`);
            return DEFAULT_LANGUAGE;
        }
        else {
            return supportedLCID;
        }
    }

    private _loadTranslations(): { [key in SupportedLCIDs]: { [key: string]: string } } {
        return {
            1029: czech,
            1033: english
        };
    }
}